export default __webpack_public_path__ + "static/media/ISEO CLASS-2 EXAM PATTERN 2026-27.78dd797e.pdf";